var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12C8.5 10.067 10.067 8.5 12 8.5H36C37.933 8.5 39.5 10.067 39.5 12V36C39.5 37.933 37.933 39.5 36 39.5H12C10.067 39.5 8.5 37.933 8.5 36V12Z",
    fill: "#EFF5FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12C8.5 10.067 10.067 8.5 12 8.5H36C37.933 8.5 39.5 10.067 39.5 12V36C39.5 37.933 37.933 39.5 36 39.5H12C10.067 39.5 8.5 37.933 8.5 36V12Z",
    stroke: "#D7E5F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.2H20V31H17V21.2ZM22.6 17H25.4V31H22.6V17ZM28.2 25H31V31H28.2V25Z",
    fill: "#005CBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImg);
export default __webpack_public_path__ + "static/media/dashboardImg.971a181d8d2df915c64fb1946f33051c.svg";
export { ForwardRef as ReactComponent };